import React from 'react'
import PropTypes from 'prop-types'

import { calculateLineItemTotal } from '../../util/strings'
import { RowContainer, Row, DataFields, BoldDataColumn, DataColumn, Total, LineTotalText } from '../styles/BillStyles'

function BillLineItemsReadOnly({ lineItems = [] }) {
  return (
    <>
      {lineItems.map((item, index) => {
        const total = calculateLineItemTotal({ quantity: item.quantity, price: item.price, tax: item.tax })
        const totalString = item.type === 'DISCOUNT' ? `($ ${total})` : `$ ${total}`
        const typeLabel = item.type === 'CHARGE' ? 'Charge' : 'Discount'

        return (
          <RowContainer key={index} data-testid="table-row">
            <Row>
              <DataFields>
                <BoldDataColumn basis="15%">{typeLabel}</BoldDataColumn>
                <BoldDataColumn basis="33%">{item.description}</BoldDataColumn>
                <DataColumn basis="11%">{item.quantity}</DataColumn>
                <DataColumn basis="18%">{item.unit}</DataColumn>
                <DataColumn basis="12%">{item.price !== null && item.price !== undefined && `$ ${item.price.toFixed(2)}`}</DataColumn>
                <DataColumn basis="10%">{item.tax !== null && item.tax !== undefined && `${item.tax} %`}</DataColumn>
              </DataFields>
              <Total>
                <LineTotalText>{totalString}</LineTotalText>
              </Total>
            </Row>
          </RowContainer>
        )
      })}
    </>
  )
}

BillLineItemsReadOnly.propTypes = {
  lineItems: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(['CHARGE', 'DISCOUNT']).isRequired,
      description: PropTypes.string,
      quantity: PropTypes.number,
      unit: PropTypes.string,
      price: PropTypes.number,
      tax: PropTypes.number
    })
  )
}

export default BillLineItemsReadOnly
